import { render, staticRenderFns } from "./assess.vue?vue&type=template&id=afa74a1a&scoped=true&"
import script from "./assess.vue?vue&type=script&lang=js&"
export * from "./assess.vue?vue&type=script&lang=js&"
import style0 from "./assess.vue?vue&type=style&index=0&id=afa74a1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa74a1a",
  null
  
)

export default component.exports